/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import ExtraServices from "reusables/sections/ExtraServices";

// Images

function OneOff_Section3() {
  return (
    <Container>
      <ExtraServices
        description="For spaces needing extra attention, we offer optional add-ons:"
        services={[
          "Deep carpet and upholstery cleaning",
          "Interior appliance cleaning (e.g., fridge, oven)",
          "Wall and ceiling cleaning",
          "Decluttering and organizing assistance",
        ]}
      />
    </Container>
  );
}

export default OneOff_Section3;
